export default "__VITE_ASSET__DDzJhxDh__"